import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { COMMON_API } from "../../../services/apiCalls/commonApi";
import { toast } from "react-toastify";
export default function LearningForm({ onSubmit, rowData }) {
  const location = useLocation();
  const pro = location.state || {};
  console.log(pro);
  const [formData, setFormData] = useState({
    date: formatDate(new Date()),
    typesOfLesson: "",

    lessonType: "",
    phase: "",
    whatHappened: "",
    whatWasImpact: "",
    impactOnFutureProjects: "",
    actionItem: "",
    status: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    const hours = String(date.getHours()).padStart(2, "0"); // Ensure two digits
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Ensure two digits
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
  const handleSubmit = async (e) => {
    for (const key in formData) {
      if (!formData[key]) {
        toast.error("Please fill in all fields!", { autoClose: 2000 });
        return;
      }
    }
    e.preventDefault();
    const state = JSON.parse(localStorage.getItem("state"));
    let obj = {
      Date: formData?.date,
      ProjectID: pro?.project_id,
      ProjectIDProjectNumber: pro?.project_id + "/" + pro?.Project_Number,
      ProjectName: pro?.Project_Name,
      Typeoflessonslearnt: formData.typesOfLesson,
      Solution: "solution",
      Product: "product",
      LessonType: formData?.lessonType,
      Phase: formData?.phase,
      WhatHappened: formData?.whatHappened,
      Whatwastheimpact: formData?.whatWasImpact,
      Howcanthischangefutureprojects: formData?.impactOnFutureProjects,
      ActionItems: formData?.actionItem,
      Status: formData?.status,
      UserID: state.user.user_id,
      Id: rowData?.Id,
    };

    const saveLearningForm = await COMMON_API.createLearningForm(obj);
    if (saveLearningForm && saveLearningForm?.status === 201) {
      toast.success(saveLearningForm?.Message, { autoClose: 2000 });
      clearData(); // Reset form data
      if (onSubmit) onSubmit();
    } else {
      toast.error(saveLearningForm?.Message, { autoClose: 2000 });
    }
  };

  useEffect(() => {
    if (rowData) {
      console.log(rowData, "rowData");
      setFormData({
        projectId: pro?.project_id,
        projectName: rowData.ProjectName || "",
        project_number: pro?.Project_Number,
        date: rowData?.Date,
        typesOfLesson: rowData?.Typeoflessonslearnt,
        // solution: rowData?.Solution,
        // product: rowData?.Product,
        lessonType: rowData?.LessonType,
        phase: rowData?.Phase,
        whatHappened: rowData?.WhatHappened,
        whatWasImpact: rowData?.Whatwastheimpact,
        impactOnFutureProjects: rowData?.Howcanthischangefutureprojects,
        actionItem: rowData?.ActionItems,
        status: rowData?.Status,
      });
    }
  }, []);
  const clearData = () => {
    setFormData({
      date: formatDate(new Date()),
      typesOfLesson: "",
      lessonType: "",
      phase: "",
      whatHappened: "",
      whatWasImpact: "",
      impactOnFutureProjects: "",
      actionItem: "",
      status: "",
    });
  };
  const handleCancelClick = () => {
    clearData();
    if (onSubmit) onSubmit();
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-6">
          <label className="label-custom">Date</label>
          <input
            disabled
            type="text"
            name="date"
            className="form-control shadow-none"
            value={formData.date}
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Project ID/Project Number</label>
          <input
            disabled
            type="text"
            name="projectId"
            className="form-control shadow-none"
            value={pro?.project_id + "/" + pro?.Project_Number}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Project Name</label>
          <input
            disabled
            type="text"
            name="projectName"
            className="form-control shadow-none"
            value={pro?.Project_Name}
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Type of lessons learnt</label>
          <select
            className="filter-label"
            name="typesOfLesson"
            value={formData.typesOfLesson}
            onChange={handleChange}
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
            }}
          >
            <option>Select lessons learnt</option>
            <option value="1">1</option>
          </select>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Solution</label>
          <input
            disabled
            type="text"
            name="solution"
            className="form-control shadow-none"
            value={pro?.solution || ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Product</label>
          <input
            disabled
            type="text"
            name="product"
            className="form-control shadow-none"
            value={pro?.product || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Lesson Type</label>
          <select
            className="filter-label"
            name="lessonType"
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
            }}
            value={formData.lessonType}
            onChange={handleChange}
          >
            <option>Select Lesson type</option>
            <option value="lesson">Lesson</option>
          </select>
        </div>
        <div className="col-6">
          <label className="label-custom">Phase</label>
          <select
            className="filter-label"
            name="phase"
            value={formData.phase}
            onChange={handleChange}
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
            }}
          >
            <option>Select Phase type</option>
            <option value="phase">Phase</option>
          </select>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">What Happened</label>
          <textarea
            type="text"
            name="whatHappened"
            className="form-control shadow-none"
            value={formData.whatHappened}
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">What was the impact</label>
          <textarea
            type="text"
            name="whatWasImpact"
            className="form-control shadow-none"
            value={formData.whatWasImpact}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">
            How can this change future projects
          </label>
          <textarea
            type="text"
            name="impactOnFutureProjects"
            className="form-control shadow-none"
            value={formData.impactOnFutureProjects}
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Action Items</label>
          <textarea
            name="actionItem"
            className="form-control shadow-none"
            value={formData.actionItem}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Status</label>
          <select
            className="filter-label"
            name="status"
            value={formData.status}
            onChange={handleChange}
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
            }}
          >
            <option>Select role type</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div className="row mt-4 pb-3">
        <div className="d-flex justify-content-center">
          <div className="m-2">
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
          <div className="m-2">
            <button className="btn btn-danger" onClick={handleCancelClick}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
